import React from "react";
import "./button.css";

function Button() {
  return (
    <>
      <div>
        <button className="btn">Click me</button>
      </div>
    </>
  );
}

export default Button;
